import React, { useState } from 'react';

const WhatsAppFAB = () => {
  const [isHovered, setIsHovered] = useState(false);
  
  // Replace with your actual WhatsApp number (include country code)
  const whatsappNumber = '447899121612';
  
  // Replace with your pre-filled message
  const message = "Hi! I'd like to enquire about TMD physiotherapy treatment.";
  
  // Replace with your brand name
  const brandName = 'The TMD Physio'; // {{REPLACE: Your brand name}}
  
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
  
  return (
    <div className="fixed bottom-8 right-8 z-50 flex flex-col items-end gap-3">
      {/* Tooltip pill - shows on hover */}
      <div
        className={`
          transition-all duration-300 ease-out
          ${isHovered ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'}
        `}
      >
        <div className="bg-white rounded-full shadow-lg px-4 py-2.5 flex items-center gap-2.5 border border-gray-200">
          {/* Brand logo placeholder - replace with your actual brand SVG */}
          <div className="w-6 h-6 rounded-full bg-teal-600 flex items-center justify-center flex-shrink-0">
            <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="12" r="10" />
            </svg>
          </div>
          <span className="text-sm font-medium text-gray-800 whitespace-nowrap">
            {brandName} · Chat with us
          </span>
        </div>
      </div>
      
      {/* FAB Container with ping animation */}
      <div className="relative">
        {/* Animated ping halo */}
        <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20"></span>
        <span className="absolute inset-0 rounded-full bg-green-500 animate-pulse opacity-10"></span>
        
        {/* Main WhatsApp button */}
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-fab"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className="
            relative block w-16 h-16 rounded-full bg-green-500 hover:bg-green-600
            shadow-lg hover:shadow-xl
            transition-all duration-300 ease-out
            hover:scale-110
            flex items-center justify-center
            group
          "
          aria-label="Chat with us on WhatsApp"
        >
          {/* Official WhatsApp logo */}
          <svg 
            className="w-9 h-9 text-white" 
            viewBox="0 0 24 24" 
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
          </svg>
        </a>
      </div>
    </div>
  );
};

export default WhatsAppFAB;
